<template>
  <v-flex class="myProfile" data-qa="myprofile-flex-tk86m">
    <ConfirmExit
      v-if="isLeavingRoute"
      v-on:isLeavingRoute="proceedLeave"
      v-on:isNotLeavingRoute="cancelLeave"
      :text = resource.confirmExit
    />
    <MyProfileAddressLookup
      v-if="addressLookupData.length"
      :search="searchAddressKey"
      :addressList="addressLookupData"
      :addAddressManually="addAddressManually"
      @close="addressLookupData = []"
      @selectAddress="updateAddressFields"
      @clickAddAddressManually="disableAddresses"
    />
    <v-layout wrap data-qa="myprofile-layout-v4i9v">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
        data-qa="myprofile-flex-whxiok">
        <v-container class="px-8 pb-10" data-qa="myprofile-container-ndtfw3">
            <v-row data-qa="myprofile-row-cz511s">
              <v-layout class="pb-2" data-qa="myprofile-layout-mfchgj">
                <v-flex v-if="showCustomerProfilePhoto" class="pt-4" xs4 sm4 md4 lg3 xl2 data-qa="myprofile-flex-ms2tsx">
                  <v-row
                    no-gutters
                    justify="center"
                    class="myProfile__customerProfilePic__wrapper-row"
                    data-qa="myprofile-row-7bqpba">
                    <div class="myProfile__customerProfilePic__wrapper-div" data-qa="myprofile-div-0jwxwb">
                      <v-avatar :tile="false" height="110" width="110" data-qa="myprofile-avatar-v8u276">
                        <v-icon
                          v-if="!customerProfilePic"
                          :size="image.height - (1 / 6) * image.height"
                          color="#F8BBD0"
                          data-qa="myprofile-icon-yp0ssp">mdi-account</v-icon
                        >
                        <img data-qa="myprofile-img-vvl3jd"
                          v-if="customerProfilePic"
                          :src="customerProfilePic"
                        />
                      </v-avatar>
                    </div>
                    <v-menu
                      v-if="enableFormEdit"
                      :close-on-click="closeOnClick"
                      offset-x
                      data-qa="myprofile-menu-51a78i">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                          class="myProfile__customerProfilePic__btnCamera"
                          data-qa="myprofile-div-e2rloj">
                          <v-btn small data-qa="myprofile-btn-daql1o">
                            <v-icon :color="secondaryColor" medium class="material-symbols-outlined"
                              data-qa="myprofile-icon-jucna">photo_camera</v-icon
                            >
                          </v-btn>
                        </div>
                      </template>
                      <v-list data-qa="myprofile-list-3nghn3">
                        <v-list-item
                          v-for="(type, i) in photoActionTypes"
                          :key="type"
                          @click="handlePhotoAction(type)"
                          :data-qa="`myprofile-list-item-3nghn3-${i}`"
                        >
                          <v-list-item-title
                            class="text-capitalize home-cards--iconPointers"
                            :data-qa="`myprofile-list-item-title-etz8i57-${i}`">{{ type }} Photo</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-row>
                </v-flex>
                <v-flex xs8 sm8 md8 lg9 xl10 class="pt-10" data-qa="myprofile-flex-428nkk">
                  <v-layout row wrap data-qa="myprofile-layout-nrtedg">
                    <v-flex xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="myprofile-flex-f87pze">
                      <font
                        class="
                          text-h5
                          font-weight-bold
                          white--text
                          text-uppercase
                        "
                        >{{ storeData.smeRelationshipDetails.relatedPartyName }}</font
                      >
                    </v-flex>
                    <v-flex v-if="showCustomerSegment" xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="myprofile-flex-neo1mm">
                      <font
                        class="subheading-1 font-weight-medium white--text"
                        >{{ userSegmentCategory }}</font
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-row>
            <v-row data-qa="myprofile-row-5jr4nv">
              <v-layout column wrap data-qa="myprofile-layout-9f8eq">
                <v-flex sm12 xs12 md12 lg12 xl12 class="text-right" data-qa="myprofile-flex-dcnbzh">
                  <v-btn
                    v-if="enableEditButton && !enableFormEdit"
                    @click="onEdit"
                    outlined
                    color="white"
                    class="text-none py-2 px-4"
                    data-qa="myprofile-btn-sn402nd">{{$t('personalSettings.buttons.edit')}}
                  </v-btn>
                  <v-btn
                    v-if="enableFormEdit"
                    @click="onFormCancel"
                    outlined
                    color="white"
                    class="text-none py-2 px-4"
                    data-qa="myprofile-btn-2g6y5">{{$t('personalSettings.buttons.cancel')}}</v-btn
                  ><span class="pr-2" data-qa="myprofile-span-xyjt3b"></span>
                  <v-btn
                    v-if="enableFormEdit"
                    @click="onSave('save')"
                    :disabled="disableModify.saveForm"
                    dark
                    outlined
                    color="white"
                    class="text-none py-2 px-4"
                    data-qa="myprofile-btn-u6wq3j">{{ $t("common.saveButton_text") }}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-row>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex
      xs12
      sm12
      md12
      lg12
      xl12
      class="pl-3 pt-6"
      order-xs-1
      order-sm-1
      order-lg-1
      data-qa="myprofile-flex-ao2ivta">
      <v-row data-qa="myprofile-row-s9iar">
        <v-flex xs12 sm12 md6 lg6 xl6 data-qa="myprofile-flex-zje8ls">
          <div v-if="!enableFormEdit && !isSmeLogin" data-qa="myprofile-div-m57ca6">
            <v-card class="py-2 pt-4" data-qa="myprofile-card-4h2jut">
              <DisplayDetails :config="displayConfig.personal" class="pl-5" />
            </v-card>
            <v-card v-if="showResidentialAddress && residentialDisplayDataList.length > 0" class="py-2 pt-4 mt-4" data-qa="myprofile-card-g45efu">
              <DisplayDetails :config="displayConfig.residential" class="pl-5" />
            </v-card>
            <v-card v-if="correspondenceDisplayDataList.length > 0" class="py-2 pt-4 mt-4" data-qa="myprofile-card-2wihqw">
              <DisplayDetails :config="displayConfig.correspondence" class="pl-5" />
            </v-card>
          </div>
          <v-card v-if="!enableFormEdit && isSmeLogin" class="py-2 pt-4" data-qa="myprofile-card-47v7l8">
            <DisplayDetails :config="displayConfig.smePersonal" class="pl-5" />
          </v-card>
          <v-divider data-qa="myprofile-divider-s9f1ix"  />
          <v-card v-if="!enableFormEdit && isSmeLogin" class="py-2 pt-4 mt-4" data-qa="myprofile-card-lm70mi">
            <DisplayDetails :config="displayConfig.smeInfo" class="pl-5" />
          </v-card>
          <!-- <v-card v-if="!enableFormEdit && isSmeLogin" class="py-2 pt-4 mt-4" data-qa="myprofile-card-skynbn">
            <DisplayDetails :config="displayConfig.office" class="pl-5" />
          </v-card> -->
          <v-card v-if="!enableFormEdit" class="py-2 pt-4 mt-4" data-qa="myprofile-card-mgqg1f">
            <DisplayDetails :config="displayConfig.otherInfo" class="pl-5" />
            <v-flex xs12 sm12 md12 lg12 xl12
              class="pl-6 pt-4"
              v-show="documentDetails && documentDetails.length && !hideDocuments"
              data-qa="myprofile-flex-xbyk9q">
              <font class="text-subtitle-1 font-weight-light">
                {{ $t('personalSettings.documentDetails') }}
              </font>
            </v-flex>
            <DisplayDetails :config="displayConfig.documentDetails" class="pl-5 pt-2" />
            <v-flex class="pt-6" v-if="displayCheckFeeStructure" data-qa="myprofile-flex-90gtj">
              <a
                :href="$appSettings.applicationSettings.checkFeeStructure"
                target="_blank"
                class="font-weight-bold pl-6"
                data-qa="myprofile-a-4b76ni">
                <font :color="primaryColor">
                  {{ $t("common.checkFeeStructure") }}
                </font>
              </a>
            </v-flex>
          </v-card>
          <div v-if="enableFormEdit && !isSmeLogin" data-qa="myprofile-div-pmdd9j">
            <Form
              :config="formConfig.personalDetails"
              @onInput="onPersonalInput"
            />
            <Form v-if="showResidentialAddress && residentialDisplayDataList.length > 0"
              @onUploadResidentialProofBtnClick="onAddressProof(addressType.RESIDENTIAL); setConfig(addressType.RESIDENTIAL);"
              :config="formConfig.residential"
            />
            <Form v-if="correspondenceDisplayDataList.length > 0"
              @onSameAsResidentialChange="onSameAsResidentialChange"
              @onUploadCorrespondenceProofBtnClick="onAddressProof(addressType.CORRESPONDENCE); setConfig(addressType.CORRESPONDENCE);"
              :config="formConfig.correspondence"
            />
          </div>
          <div v-if="enableFormEdit && isSmeLogin" data-qa="myprofile-div-vi08qs">
            <Form :config="formConfig.smePersonalDetails" />
            <Form :config="formConfig.smeDetails" />
          </div>
        </v-flex>
        <v-flex v-if="enableFormEdit" xs12 sm12 md6 lg6 xl6 data-qa="myprofile-flex-83pf7s">
          <my-profile-address-proof
            v-if="residentialDoc"
            address-doc-type="residential"
            @onMyProfileAddressProofExitIconClick="confirmDelete('residential')"
            @onMyProfileAddressPdfPreviewClick="displayPdf('residential')"
          />
          <my-profile-address-proof
            v-if="correspondenceDoc"
            address-doc-type="correspondence"
            @onMyProfileAddressProofExitIconClick="confirmDelete('correspondence')"
            @onMyProfileAddressPdfPreviewClick="displayPdf('correspondence')"
          />
        </v-flex>
      </v-row>
    </v-flex>

    <OtpHandler
      v-if="showOTPScreen"
      @otp-cancelled="showOTPScreen = false"
      @otp-success="saveAmendData"
    />

    <!-- Address Doc preview -->
    <Modal
      :config="modalConfig.pdfPreview"
      @btn1Action="modalConfig.pdfPreview.enabled = false"
    >
      <div slot="modalContent" id="viewPdfFile" class="pdf-viewer" data-qa="myprofile-div-udiaga"></div>
    </Modal>

    <!-- Address Proof Upload -->
    <DocUpload
      v-if="onProofClick"
      @close="onDocClose($event)"
      @customerPicture="updateCustomerPic($event)"
      :config="{
        enabled: onProofClick,
        type: selectUploadType,
        modalTitle: selectModalTitle,
      }"
    />

    <div class="mb-1" v-if="tips.enabled" data-qa="myprofile-div-c9dsh5">
      <v-alert
        icon="mdi-information-outline"
        class="v-alert--info"
        v-for="(tip, i) in tips.tipMessages"
        :key="tip"
        :data-qa="`myprofile-alert-2g6y5-${i}`"
      >
        {{ $t(`screenTips.${tip}`) }}
      </v-alert>
    </div>

    <Modal
      v-if="showSuccessModal"
      :config="amendSuccess ? modalConfig.myProfileSuccess : modalConfig.myProfileFailed"
      @btn2Action="onSuccessModalClose"
    >
      <span v-if="amendMsgArray && amendMsgArray.length > 0" slot="modalContent" class="font-weight-bold" data-qa="myprofile-span-y5tyh">
        <v-flex v-for="(item, i) in amendMsgArray" :key="item.msg" :data-qa="`myprofile-flex-2g6y5-${i}`">
          <v-row no-gutters :data-qa="`myprofile-row-j3xyu5-${i}`">
            <v-flex xs2 sm2 md2 lg2 xl2 :data-qa="`myprofile-flex-6r91q-${i}`">
              <v-icon :color="item.checked ? 'green' : 'red'" left medium :data-qa="`myprofile-icon-9a3u8w-${i}`">{{ getIcon(item.checked) }}</v-icon>
            </v-flex>
            <v-flex xs9 sm9 md9 lg9 xl9 :data-qa="`myprofile-flex-bjtwy2-${i}`">
              <span :data-qa="`myprofile-span-h94mnv-${i}`">
                {{ item.msg }}
              </span>
            </v-flex>
          </v-row>
        </v-flex>
      </span>
    </Modal>
  </v-flex>
</template>

<script>
import '@/styles/pages/photoCapture.scss'
import '@/styles/pages/myProfile.scss'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import CommonService from '@/service/commonService.js'
import getFormConfig from '@/util/formUtility.js'
import PDFObject from '@/core/_helpers/pdfViewer'
import preload from '@/util/preload'
import store from '@/core/store'
import event from '@/util/event'
import decrypt from '@/util/decrypt'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { rearrangeSchemaBySequence } from '@/composables/useSchemaUtils'

export default {
  name: 'MyProfile',
  components: {
    DisplayDetails,
    DocUpload: () => import('@/views/myprofile/DocUpload.vue'),
    Modal: () => import('@/components/common/Modal.vue'),
    Form: () => import('@/components/DOB-Form/Form.vue'),
    ConfirmExit: () => import('@/components/common/ConfirmExit.vue'),
    MyProfileAddressProof: () => import('@/views/myprofile/MyProfileAddressProof'),
    MyProfileAddressLookup: () => import('@/views/myprofile/MyProfileAddressLookup'),
    OtpHandler: () => import('@/components/common/OtpHandler.vue')
  },
  data () {
    return {
      enableOTP: this.$appSettings.defaultConfigurations.myProfileScreen.enableOTP,
      enableMandatoryAddressProofUpload: this.$appSettings.defaultConfigurations.myProfileScreen.enableMandatoryAddressProofUpload,
      defaultCountryCode: this.$appSettings.defaultConfigurations.countryISDCode,
      showCustomerProfilePhoto: this.$appSettings.defaultConfigurations.myProfileScreen.showCustomerProfilePhoto,
      enableAddressAmendment: this.$appSettings.defaultConfigurations.myProfileScreen.enableAddressAmendment,
      enableAddressLookup: this.$appSettings.defaultConfigurations.myProfileScreen.enableAddressLookup,
      enableManualEntryForAddressLookup: this.$appSettings.defaultConfigurations.myProfileScreen.enableManualEntryForAddressLookup,
      addressLookupServiceProvider: this.$appSettings.defaultConfigurations.myProfileScreen.addressLookupServiceProvider,
      enableManualAddressEntry: false,
      showResidentialAddress: this.$appSettings.defaultConfigurations.myProfileScreen.showResidentialAddress,
      showRegisteredOfficeAddress:this.$appSettings.defaultConfigurations.myProfileScreen.showRegisteredOfficeAddress,
      showCustomerSegment: this.$appSettings.defaultConfigurations.myProfileScreen.showCustomerSegment,
      configuredAddressValidToDate: this.$appSettings.defaultConfigurations.myProfileScreen.maintainAddressChangeHistory.validToDate,
      showUseForCommunicationOption: this.$appSettings.defaultConfigurations.myProfileScreen.maintainAddressChangeHistory.showUseForCommunicationOption,
      enableEditButton: this.$appSettings.defaultConfigurations.myProfileScreen.enableEditButton,
      displayCheckFeeStructure: this.$appSettings.defaultConfigurations.myProfileScreen.displayCheckFeeStructure,
      hideEmailValidity: '',
      hidePhoneNoValidity: '',
      hideResidAddressValidity: '',
      hideCorrAddressValidity: '',
      hideSmeEmailValidity: '',
      hideSmePhoneNoValidity: '',
      hideDocuments: '',
      hideOtherInfo: false,
      documentListLimit: 5,
      docTypes: [],
      addressLookupData: [],
      statesList: [],
      documentDetails: [],
      showOTPScreen: false,
      enableFormEdit: false,
      onProofClick: false,
      onUploadResidentialProofClick: false,
      onUploadCorrespondenceProofClick: false,
      showModal: false,
      showSuccessModal: false,
      selectUploadType: '',
      deleteUploadType: '',
      selectModalTitle: '',
      customerProfilePic: '',
      documentName: '',
      userSegmentCategory: '',
      updateForm: false,
      displayDataList: [],
      residentialDisplayDataList: [],
      correspondenceDisplayDataList: [],
      smeInfo: [],
      otherInfoDIsplayDataList: [],
      smePersonalInfo: [],
      photoActionTypes: ['Upload', 'Remove'],
      enablePdfViewer: false,
      storeData: {},
      disableAddressForm: false,
      disablePersonalDetailsForm: false,
      documentResponseData: undefined,
      amendMsgArray: [],
      titleList: [],
      amendMessage: '',
      customer: {
        title: '',
        firstName: '',
        lastName: '',
        name: '',
        dateOfBirth: '',
        emailAddress: '',
        phoneNumber: '',
        address: {
          postCode: '',
          country: '',
          stateOrProvince: '',
          stateOrProvinceDescription: '',
          townOrCity: '',
          addressLine1: '',
          addressLine2: ''
        }
      },
      closeOnClick: true,
      disableModify: {
        emailAddress: true,
        phoneNumber: true,
        address: true,
        saveForm: true
      },
      modalConfig: {
        pdfPreview: {
          enabled: false,
          title: 'Preview Address Proof',
          width: '800px',
          persistent: true,
          btn1Label: 'Close'
        },
        myProfileSuccess: {
          enabled: true,
          title: this.$t('personalSettings.updateSuccess'),
          persistent: true,
          btn2Label: this.$t('common.okay'),
          width: 500
        },
        myProfileFailed: {
          enabled: true,
          title: this.$t('personalSettings.fileUpload.amendFailure'),
          persistent: true,
          btn2Label: this.$t('common.okay'),
          width: 500
        }
      },
      image: {
        height: this.$appSettings.defaultConfigurations.uploadCustomerPhotoHeight,
        width: this.$appSettings.defaultConfigurations.uploadCustomerPhotoWidth
      },
      schema: {
        addressDetails: { exists: true },
        personalDetails: { exists: true },
        residential: { exists: true },
        correspondence: { exists: true },
        smePersonalDetails: { exists: true },
        smeDetails: { exists: true },
        office: { exists: true }
      },
      documentDefaultData: {
        businessType: 'PARTY',
        docCategory: this.$appSettings.defaultConfigurations.myProfileScreen.addressDocumentCategory
      },
      tips: {
        enabled: this.$appSettings.screenTips.customerProfile.enabled,
        tipMessages: this.$appSettings.screenTips.customerProfile.tipMessages
      },
      customerPhotoDefaultData: {
        imageType: 'PHOTO',
        captionInfo: Date.now()
      },
      clippedImage: false,
      imageId: '',
      imageDates: [],
      isPristine: false,
      isAmendComplete: false,
      accountConfig: null,
      isLeavingRoute: false,
      to: null,
      refresh: true,
      customerImageId: '',
      declarationAndConsent: this.$appSettings.consentDeclarationContents,
      consentForMarketing: false,
      setChannelOnce: false,
      marketingChannels: {},
      appConsent: {},
      marketingChannelsDetails: {},
      photoUploadFailed: false,
      isPhotoUploadInitiated: false,
      documentUploadFailed: false,
      amendSuccess: false,
      isAmendDataValid: false,
      hidePreviewAction: false,
      isLogout: false,
      openAddressLookup: false,
      searchAddress: '',
      selectAddress: '',
      countryList: [],
      isSmeLogin: false,
      corporateId: '',
      customerCode: '',
      defaultCorporateCode: '',
      username: '',
      userId: '',
      userCorporates: [],
      addressType: Object.freeze({
        RESIDENTIAL: 'residential',
        CORRESPONDENCE: 'correspondence'
      }),
      companyDisplayDataList: [],
      companyAddressDataList: [],
      smeAddressInfo: [],
      residentialDoc: null,
      correspondenceDoc: null,
      residentialDocName: '',
      correspondenceDocName: '',
      searchKey: '',
      oldCountry: '',
      success: {
        amend: false, photo: false, residential: false, correspondence: false
      },
      apiCall: {
        amend: false, photo: false, residential: false, correspondence: false
      },
      hasResidential: false,
      hasCorrespondence: false,
      isPersonalDetailsValid: true,
      isResidentialAddressValid: true,
      isCorrespondenceAddressValid: true,
      showAddressLookupCloseConfirmation: false,
      searchAddressKey: '',
      addAddressManually: false,
      profilePhotoCounter: 1,
      disableAddressUpdate: this.$appSettings.defaultConfigurations.myProfileScreen.disableAddressUpdateIfLoanOutstanding
    }
  },
  async created () {
    const { get } = this
    this.isSmeLogin = get('isSmeLogin') || false
    store.dispatch('profileStore/setProfileData', {
      isSmeLogin: this.isSmeLogin
    })
    this.userId = get('userId') || ''
    this.username = get('username') || ''
    this.customerCode = get('customerCode') || ''
    this.corporateId = get('corporateId') || ''
    this.defaultCorporateCode = get('defaultCorporateCode') || ''
    this.userCorporates = get('userCorporates') || []

    // fetch customer details API call
    await preload.getCustomerDetails(this.isSmeLogin ? this.customerCode : this.username)
    await this.getGenericCodes()
    store.dispatch('appStore/setAppData', { inProgress: true })
    this.deleteUploads()
    this.resetApiFlags()
    if (this.showCustomerProfilePhoto) {
      this.checkCustomerPhoto()
    }
    await this.getCustomerPersonalDetails()
    event.$on('triggerAddressLookup', ({ searchKey, searchValue }) => {
      this.searchAddressKey = searchValue
      if (!this.enableAddressLookup) {
        this.enableManualAddressEntry = true
        this.setManualAddressEntry()
        this.dispatchError(this.resource.equifaxServiceUnavailable)
        return
      }
      if (searchValue) {
        this.addressLookup({ searchKey, searchValue })
        this.openAddressLookup = true
      }
    })
    event.$on('disableSave', (arg) => {
      this.checkFormSanity(arg)
    })
    event.$on('isValid', (arg, form) => {
      if (form === 'PersonalDetails') this.isPersonalDetailsValid = arg
      if (form === 'ResidentialAddress') this.isResidentialAddressValid = arg
      if (form === 'CorrespondenceAddress') this.isCorrespondenceAddressValid = arg

      this.isAmendDataValid = arg
      if (this.updateForm) {
        if (this.isPersonalDetailsValid && this.isResidentialAddressValid && this.isCorrespondenceAddressValid) {
          this.disableModify.saveForm = false
        } else {
          this.disableModify.saveForm = true
        }
      }
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
    event.$on('restoreForm', (formName) => {
      this.isSmeLogin ? preload.getCustomerDetails(this.customerCode) : preload.getCustomerDetails(this.username)
      this.setDisplayData()
      store.dispatch('appStore/setAppData', { inProgress: false })
    })
    event.$on('OTP_RESENT', (arg) => {
      this.modalConfig.otp.enableSave = true
    })
    event.$on('docImageUploaded', (arg) => {
      if (!this.$store.getters['profileStore/profileData']) return

      if (arg === 'customerDoc' && this.selectUploadType === 'customerDoc') {
        this.clippedImage = true
        this.customerProfilePic = this.$store.getters['profileStore/profileData'].customerDoc
      }

      const { addressDoc } = store.getters['profileStore/profileData']
      if (addressDoc) {
        const { residential, correspondence } = addressDoc
        this.residentialDoc = residential?.data ?? null
        this.residentialDocName = residential?.file?.name ?? ''
        this.correspondenceDoc = correspondence?.data ?? null
        this.correspondenceDocName = correspondence?.file?.name ?? ''
      }

      if ((this.docUploaded() || this.customerProfilePic) && this.isAmendDataValid) {
        this.disableModify.saveForm = false
      }
    })
    event.$on('editCheck', (arg) => {
      if (arg) {
        this.updateForm = true
      }
    })
  },
  computed: {
    resource () {
      return {
        residentialProofIsMandatory: this.$t('personalSettings.addressLookup.uploadResidentailAddressProofMandatory'),
        correspondenceProofIsMandatory: this.$t('personalSettings.addressLookup.uploadCorrespondenceAddressProofMandatory'),
        noMatchingAddress: this.$t('personalSettings.addressLookup.noMatchingAddress'),
        noMatchingPostCode: this.$t('personalSettings.addressLookup.noMatchingPostCode'),
        equifaxServiceUnavailable: this.$t('personalSettings.addressLookup.equifaxServiceUnavailable'),
        noMatchingSearchText: this.$t('personalSettings.addressLookup.noMatchingSearchText'),
        noMatchingSearchTextUseManual: this.$t('personalSettings.addressLookup.noMatchingSearchTextUseManual'),
        lookupUnavailable: this.$t('personalSettings.addressLookup.lookupUnavailable'),
        lookupUnavailableUseManual: this.$t('personalSettings.addressLookup.lookupUnavailableUseManual'),
        confirmExit: this.$t('personalSettings.confirmExit')
      }
    },
    formConfig () {
      return {
        personalDetails: {
          label: this.schema.personalDetails?.title,
          icon: 'mdi-pencil',
          name: 'PersonalDetails',
          isEnabled: true,
          toolbar: true,
          form: this.schema.personalDetails
        },
        residential: {
          label: this.schema.residential?.title,
          icon: 'mdi-pencil',
          name: 'ResidentialAddress',
          form: this.schema.residential
        },
        correspondence: {
          label: this.schema.correspondence?.title,
          icon: 'mdi-pencil',
          name: 'CorrespondenceAddress',
          form: this.schema.correspondence
        },
        smePersonalDetails: {
          label: this.schema.smePersonalDetails?.title,
          icon: 'mdi-pencil',
          name: 'SmePersonalDetails',
          isEnabled: true,
          toolbar: true,
          form: this.schema.smePersonalDetails
        },
        smeDetails: {
          label: this.schema.smeDetails?.title,
          icon: 'mdi-pencil',
          name: 'SmeDetails',
          isEnabled: true,
          toolbar: true,
          form: this.schema.smeDetails
        }
      }
    },
    displayConfig () {
      return {
        personal: {
          title: `${this.$t('personalSettings.personalInformation')}`,
          dataList: this.displayDataList,
          translation: 'personalSettings.label'
        },
        residential: {
          title: `${this.$t('personalSettings.residentialAddress')}`,
          dataList: this.residentialDisplayDataList,
          translation: 'personalSettings.label'
        },
        correspondence: {
          title: `${this.$t('personalSettings.correspondenceAddress')}`,
          dataList: this.correspondenceDisplayDataList,
          translation: 'personalSettings.label'
        },
        smePersonal: {
          title: `${this.$t('personalSettings.personalInformation')}`,
          dataList: this.smePersonalInfo,
          translation: 'personalSettings.label'
        },
        smeInfo: {
          title: `${this.$t('personalSettings.smeInformation')}`,
          dataList: this.smeInfo,
          translation: 'personalSettings.label'
        },
        otherInfo: {
          title: `${this.$t('personalSettings.otherInformation')}`,
          dataList: this.otherInfoDIsplayDataList,
          translation: 'personalSettings.label'
        },
        documentDetails: {
          dataList: this.documentDetails
        },
        office: {
          title: `${this.$t('personalSettings.registeredOffice')}`,
          dataList: this.smeAddressInfo,
          translation: 'personalSettings.label'
        }
      }
    },
    ...mapGetters({ profileData: 'profileStore/profileData' }),
    emailValidity () {
      const { EMAIL } = this.profileData.customerDetails
      return EMAIL.toDate || ''
    },
    phoneValidity () {
      const { PHONE } = this.profileData.customerDetails
      return PHONE.toDate || ''
    }
  },
  methods: {
    getItem: (item) => JSON.parse(sessionStorage.getItem(item)),
    getIcon (item) {
      return item ? 'mdi-check' : 'mdi-close'
    },
    async getGenericCodes () {
      const code = {
        codeReferences: [
          { reference: '232' },
          { reference: '214' },
          { reference: '224' },
          { reference: '257' },
          { reference: 'COUNTRYNAME' },
          { reference: '002' }
        ]
      }
      await preload.getGenericCodes(code)
      this.getCountriesList()
    },
    getTitleDescription (title) {
      const titleCodes = JSON.parse(localStorage.getItem('002'))
      let description = ''
      if (!titleCodes) {
        return title
      }
      titleCodes.forEach((code) => {
        if (code.codeReference === title) {
          description = code.codeDescription
        }
      })
      return description
    },
    getCountriesList () {
      const countryCodes = JSON.parse(sessionStorage.getItem('COUNTRYNAME'))
      if (countryCodes) {
        this.countryList = countryCodes
        return
      }
      this.countryList = [{ codeReference: 'GBR', codeDescription: 'United Kingdom' }]
    },
    async onEdit () {
      // Hide Information that cannot be edited
      this.schema.personalDetails.schema.emailValidity.hidden = true
      this.schema.personalDetails.schema.phoneNoValidity.hidden = true
      this.schema.residential.schema.addressValidity.hidden = true
      this.schema.correspondence.schema.addressValidity.hidden = true

      this.enableFormEdit = !this.enableFormEdit
      this.photoUploadFailed = false
      this.documentUploadFailed = false
      this.disableModify.saveForm = true
      this.clippedImage = false
      this.amendSuccess = false
      this.updateForm = false
      if (this.docUploaded()) {
        this.documentName = ''
        this.enablePdfViewer = false
      }
      await this.setFormData()
      this.setManualAddressEntry()
      setTimeout(() => {
        event.$emit('resetFormValidation', true)
        event.$emit('validateForm', true)
      }, 1000)

      // Disable address update if user has atleast one loan account with outstanding amount > 0
      if (this.disableAddressUpdate) {
        const loanAccounts = store.getters['userStore/userData'].loanAccounts
        const hasLoanWithOutstandingAmt = loanAccounts && loanAccounts.some(acct => acct.loanOutstandingAmount.amount > 0)
        if (hasLoanWithOutstandingAmt) {
          this.disableAddressFields(this.schema.correspondence.schema, true)
          this.schema.correspondence.schema.searchCorrespondenceAddress.hidden = true
          this.schema.correspondence.schema.uploadCorrespondenceProofBtn.disabled = true
          this.schema.correspondence.schema.sameAsResidential.hidden = true

          if (this.hasResidential && this.showResidentialAddress) {
            this.disableAddressFields(this.schema.residential.schema, true)
            this.schema.residential.schema.searchResidentialAddress.hidden = true
            this.schema.residential.schema.uploadResidentialProofBtn.disabled = true
          }
        }
      }
    },
    handlePhotoAction (actionType) {
      if (actionType === 'Upload') {
        this.reset()
        this.setConfig('customerDoc')
      } else {
        if (actionType === 'Remove') {
          this.confirmDelete('customerDoc')
        }
      }
    },
    onFormCancel () {
      this.enableFormEdit = !this.enableFormEdit
      this.enableManualAddressEntry = false
      if (this.docUploaded()) {
        this.documentName = ''
        this.enablePdfViewer = false
      }
      if (this.photoUploadFailed) {
        this.customerProfilePic = ''
      }
      if (this.showCustomerProfilePhoto) {
        this.checkCustomerPhoto()
      }
      this.isAmendComplete = true
      this.setDisplayData()
      this.setManualAddressEntry()
      this.deleteUploads()
      this.resetApiFlags()
    },
    async getCustomerPersonalDetails () {
      if (this.isSmeLogin) {
        const [smePersonal, smeDetails, registeredOffice] = await Promise.all([
          CommonService.getFormData(`SmePersonalDetails-${this.$i18n.locale}`),
          CommonService.getFormData(`SmeDetails-${this.$i18n.locale}`),
          CommonService.getFormData(`Registered-Office-${this.$i18n.locale}`)
        ])

        Object.assign(this.schema, {
          smePersonalDetails: getFormConfig(smePersonal),
          smeDetails: getFormConfig(smeDetails),
          office: getFormConfig(registeredOffice)
        })
        this.hideSmePhoneNoValidity = this.schema.smePersonalDetails.schema.phoneNoValidity.hidden
        this.hideSmeEmailValidity = this.schema.smePersonalDetails.schema.emailValidity.hidden

        // Rearrange schema keys based on sequence property using composable
        this.schema.smePersonalDetails = rearrangeSchemaBySequence(this.schema.smePersonalDetails)
        this.schema.smeDetails = rearrangeSchemaBySequence(this.schema.smeDetails)
        this.schema.office = rearrangeSchemaBySequence(this.schema.office)
      }

      // TODO: Ideally this should only be called if it is not SME login. But since the data here are accessed elsewhere without checking if its not SME, keeping it as is for now.
      const [personal, residential, correspondence, otherInfo] = await Promise.all([
        CommonService.getFormData(`PersonalDetails-${this.$i18n.locale}`),
        CommonService.getFormData(`Address-Residential-${this.$i18n.locale}`),
        CommonService.getFormData(`Address-Correspondence-${this.$i18n.locale}`),
        CommonService.getFormData(`Other-Information-${this.$i18n.locale}`)
      ])

      Object.assign(this.schema, {
        personalDetails: getFormConfig(personal),
        residential: getFormConfig(residential),
        correspondence: getFormConfig(correspondence),
        otherInfo: getFormConfig(otherInfo)
      })

      // Rearrange schema keys based on sequence property using composable
      this.schema.personalDetails = rearrangeSchemaBySequence(this.schema.personalDetails)
      this.schema.residential = rearrangeSchemaBySequence(this.schema.residential)
      this.schema.correspondence = rearrangeSchemaBySequence(this.schema.correspondence)
      this.schema.otherInfo = rearrangeSchemaBySequence(this.schema.otherInfo)

      this.hideEmailValidity = this.schema.personalDetails.schema.emailValidity.hidden
      this.hidePhoneNoValidity = this.schema.personalDetails.schema.phoneNoValidity.hidden
      this.hideResidAddressValidity = this.schema.residential.schema.addressValidity.hidden
      this.hideCorrAddressValidity = this.schema.correspondence.schema.addressValidity.hidden
      this.documentListLimit = this.schema.otherInfo.schema.documentDetails.displayLimit
      this.docTypes = this.schema.otherInfo.schema.documentDetails.docTypes
      this.hideDocuments = this.schema.otherInfo.schema.documentDetails.hidden

      if (this.documentListLimit && this.hideDocuments && !this.displayCheckFeeStructure) {
        this.hideOtherInfo = true
      }

      this.setDisplayData()

      this.storeData = store.getters['profileStore/profileData'].customerDetails
      if (this.storeData) {
        Object.assign(this.customer, this.storeData)
      }
      //Customization  - Start - Segment assignment-- DOBC-601
      //If the current user is SME user, segment to be picked from corporate details
      //this.userSegmentCategory = this.storeData.segmentCategoryDesc
        const userSegment = this.isSmeLogin ? this.storeData.smeSegmentKYCDetails.segmentCategoryDescription : this.storeData.segmentCategoryDesc
        this.userSegmentCategory =  `${userSegment} Customer`
      //Customization - End
      this.consentForMarketing = this.storeData.preferences
      if (this.schema.personalDetails.schema && this.schema.personalDetails.schema.userLoginId && !this.schema.personalDetails.schema.userLoginId.hidden) {
        this.schema.personalDetails.model.userLoginId = this.getItem('username')
      }
    },
    setMarketingChannelsData () {
      if (
        this.consentForMarketing &&
        this.consentForMarketing.consentForMarketing
      ) {
        this.declarationAndConsent.consentForMarketing.isChecked = true
        const key = Object.values(this.consentForMarketing.marketingChannels)
        key.forEach((channel) => {
          if (channel) {
            const { channelName } = channel
            if (channelName === 'SMS') {
              this.declarationAndConsent.consentForMarketing.options[0].isChecked = true
            } else {
              this.declarationAndConsent.consentForMarketing.options[1].isChecked = true
            }
          }
        })
      }
    },
    async checkCustomerPhoto () {
      const partyID = this.isSmeLogin ? this.customerCode : this.username
      if (partyID) {
        let imageId = ''
        const response = await CommonService.checkPhotoForCustomer(
          partyID
        )
        if (response && !response.causes) {
          if (response.items && response.items.length > 1) {
            response.items.forEach((image) => {
              const uploadTime = image.captionInfo
              this.imageDates.push(uploadTime)
            })
            this.sortedImageDates = []
            this.sortedImageDates.push(...this.imageDates)
            imageId = this.getCustomerImageId(response, this.profilePhotoCounter)
          } else {
            imageId = response.items.length ? response.items[0].imageId : ''
          }
        }
        if (imageId) {
          this.customerImageId = imageId
          const fetchedCustomerPhoto = await CommonService.getPhotoForCustomer(imageId)
          if (fetchedCustomerPhoto) {
            this.customerProfilePic = fetchedCustomerPhoto
          } else this.profilePhotoCounter++

          if (!fetchedCustomerPhoto && (this.profilePhotoCounter < response.items.length)) {
            imageId = this.getCustomerImageId(response, this.profilePhotoCounter)
            const fetchedCustomerPhoto = await CommonService.getPhotoForCustomer(imageId)
            this.customerProfilePic = fetchedCustomerPhoto
          }
        }
      }
    },
    getCustomerImageId (response, reduceLengthFrom) {
      let imageId = ''
      this.sortedImageDates.sort()
      const index = this.imageDates.indexOf(
        this.sortedImageDates[this.sortedImageDates.length - reduceLengthFrom]
      )
      imageId = response.items[index].imageId
      return imageId
    },
    displayPdf (addressDocType) {
      this.modalConfig.pdfPreview.enabled = true
      let document
      if (addressDocType === 'residential') document = this.residentialDoc
      if (addressDocType === 'correspondence') document = this.correspondenceDoc
      setTimeout(() => {
        PDFObject.embed(document, '#viewPdfFile', { forcePDFJS: true })
      }, 10)
    },
    async getStatesList (country) {
      // if country has not changed, return existing statelist
      if (this.oldCountry === country) return this.statesList

      this.oldCountry = country

      // get list from API
      try {
        const states = await CommonService.getCountryStates(country)
        if (states?.StateProvinceDetails) {
          this.statesList = states.StateProvinceDetails
        }
      } catch (e) {
        console.log(e)
      }
    },
    async addressLookup ({ searchKey, searchValue }) {
      this.openAddressLookup = false
      this.searchKey = searchKey
      try {
        const addresses = await CommonService.postAddressLookup({ addressLine1: searchValue })
        // Success
        if (addresses?.addressDetails) {
          this.addressLookupData = addresses.addressDetails
          this.openAddressLookup = true
          return
        }
        const serviceNotAvailable = this.isServiceNotAvailabe(addresses)
        if (this.enableManualEntryForAddressLookup) {
          this.enableManualAddressEntry = true
          this.setManualAddressEntry()
          this.dispatchError(serviceNotAvailable ? this.resource.lookupUnavailableUseManual : this.resource.noMatchingSearchTextUseManual)
          return
        }
        this.dispatchError(serviceNotAvailable ? this.resource.lookupUnavailable : this.resource.noMatchingSearchText)
      } catch (e) {
        console.log(e)
      }
    },
    dispatchError (content) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title: 'Error',
          content,
          type: 'error',
          width: 400,
          persistent: true,
          close: true,
          component: 'dob-modal'
        }
      })
    },
    hideSameAsResidentialCheckBox () {
      if (!this.hasResidential) return true // hide when there is no residential address
      if (!this.showResidentialAddress) return true // hide when show resisdential address is disabled
      return false
    },
    resetSchemaModel () {
      const model = {
        // title: '',
        name: '',
        dateOfBirth: '',
        emailAddress: '',
        phoneNumber: ''
      }
      Object.assign(this.schema.personalDetails.model, model)
      Object.assign(this.schema.correspondence.model, { sameAsResidential: false, searchCorrespondenceAddress: null })
      Object.assign(this.schema.residential.model, { searchResidentialAddress: null })
      this.schema.correspondence.schema.sameAsResidential.hidden = this.hideSameAsResidentialCheckBox()
      this.hideCorrespondenceAddress(false)

      if (this.isSmeLogin) {
        Object.assign(this.schema.smePersonalDetails.model,
          {
            name: '',
            emailAddress: '',
            phoneNumber: '',
            relatedPartyName: '',
            relationshipTypeDescription: ''
          }
        )
        Object.assign(this.schema.smeDetails.model, { defaultCorporateCode: '' })
      }
    },
    getDataValue: (object, path, defaultValue = '') => {
      let value
      if (path?.parentObject) {
        value = object[path?.parentObject][path?.key]
      } else {
        value = path.split('.').reduce((o, p) => (o ? o[p] : undefined), object)
      }
      if (typeof value === 'boolean') {
        return value ? 'true' : 'false'
      }
      return value || defaultValue
    },
    setPersonalDataList () {
      const { customerDetails } = this.profileData
      const { schema } = this.schema.personalDetails

      this.displayDataList = Object.entries(schema)
        .filter(([, { hidden, displayData, labelValueMapping }]) =>
          !hidden && displayData && labelValueMapping
        )
        .map(([field, { labelValueMapping }]) => {
          let label
          let value

          switch (field) {
            case 'dateOfBirth':
              label = customerDetails.isEnterpriseCustomer ? 'DOI' : 'DOB'
              value = this.$formatter.formatDate(this.getDataValue(customerDetails, labelValueMapping))
              break
            case 'emailValidity':
              label = field
              value = this.emailValidity
              break
            case 'phoneNoValidity':
              label = field
              value = this.phoneValidity
              break
            case 'preferredContact':
              label = field
              value = this.formatContact(customerDetails.preferredContact)
              break
            default:
              label = field
              value = this.getDataValue(customerDetails, labelValueMapping)
              break
          }

          return { label, value }
        })
    },
    setCorrespondenceDataList () {
      const { originalCorrespondenceAddr } = this.profileData
      const { schema } = this.schema.correspondence
      const addressObj = {
        address: { ...originalCorrespondenceAddr }
      }

      if (originalCorrespondenceAddr) {
        this.correspondenceDisplayDataList = Object.entries(schema)
          .filter(([field, { hidden, displayData, labelValueMapping }]) => {
            return !hidden && displayData && labelValueMapping &&
            (field !== 'isDefault' || this.getDataValue(addressObj, labelValueMapping) === 'true')
          })
          .map(([field, { labelValueMapping }]) => {
            if (field === 'isDefault') {
              return {
                label: field,
                attachIcon: {
                  icon: 'mdi-checkbox-marked-circle',
                  color: this.successColor
                }
              }
            }

            const value = this.getDataValue(addressObj, labelValueMapping)
            return { label: field, value }
          })
      }
    },
    setResidentialDataList () {
      const { originalResidentialAddr } = this.profileData
      const { schema } = this.schema.residential
      const addressObj = {
        otherAddressTypes: { ...originalResidentialAddr }
      }

      if (originalResidentialAddr) {
        this.residentialDisplayDataList = Object.entries(schema)
          .filter(([field, { hidden, displayData, labelValueMapping }]) => {
            return !hidden && displayData && labelValueMapping &&
            (field !== 'isDefault' || this.getDataValue(addressObj, labelValueMapping) === 'true')
          })
          .map(([field, { labelValueMapping }]) => {
            if (field === 'isDefault') {
              return {
                label: field,
                attachIcon: {
                  icon: 'mdi-checkbox-marked-circle',
                  color: this.successColor
                }
              }
            }

            const value = this.getDataValue(addressObj, labelValueMapping)
            return { label: field, value }
          })
      }
    },
    setOtherInfoDataList (getCustomerDetails) {
      Object.keys(this.schema.otherInfo.schema).forEach((field) => {
        if (!this.schema.otherInfo.schema[field].hidden &&
          this.schema.otherInfo.schema[field].displayData &&
          this.schema.otherInfo.schema[field].labelValueMapping
        ) {
          if (this.schema.otherInfo.schema[field]?.labelValueMapping?.parentObject && getCustomerDetails.basicDetails?.[this.schema.otherInfo.schema[field]?.labelValueMapping?.parentObject]) {
            const value = getCustomerDetails.basicDetails?.[this.schema.otherInfo.schema[field]?.labelValueMapping]
            this.schema.otherInfo.model[field] = value
            if (field === 'documentDetails') {
            } else {
              this.otherInfoDIsplayDataList.push({
                label: field,
                value
              })
            }
          } else {
            const value = getCustomerDetails.basicDetails?.[this.schema.otherInfo.schema[field]?.labelValueMapping]
            this.schema.otherInfo.model[field] = value
            if (field === 'documentDetails') {
            } else {
              this.otherInfoDIsplayDataList.push({
                label: field,
                value
              })
            }
          }
        }
      })
    },
    async setFormData () {
      const { originalUserData } = store.getters['profileStore/profileData']
      const { customerDetails, otherAddressTypes } = originalUserData
      const residential = this.getResidential(otherAddressTypes)
      const { address: correspondence } = customerDetails
      this.hasResidential = !!residential
      this.hasCorrespondence = !!correspondence

      if (!this.isSmeLogin) {
        if (this.hasResidential && !this.hasCorrespondence) {
          this.schema.residential.schema.isDefault.disabled = !!this.schema.residential.model?.isDefault
        }
        if (!this.hasResidential && this.hasCorrespondence) {
          this.schema.correspondence.schema.isDefault.disabled = !!this.schema.correspondence.model?.isDefault
        }
        if (!this.showUseForCommunicationOption) {
          if (this.schema.correspondence.schema && this.schema.correspondence.schema?.isDefault) {
            this.schema.correspondence.schema.isDefault.hidden = true
          }
          if (this.schema.residential.schema && this.schema.residential.schema?.isDefault) {
            this.schema.residential.schema.isDefault.hidden = true
          }
        }
      }

      this.resetSchemaModel()
      this.getCountryFieldList()
      this.setPreferredContactList()
      if (this.isSmeLogin) { this.setSmeFormDetails() }

      Object.assign(this.schema.residential.model, residential)
      Object.assign(this.schema.correspondence.model, correspondence)

      if (residential) {
        await this.getStatesList(residential.country)
        this.schema.residential.schema.stateOrProvince.items = this.statesList
      }

      if (correspondence) {
        await this.getStatesList(correspondence.country)
        this.schema.correspondence.schema.stateOrProvince.items = this.statesList
      }

      // Set User Personal Details
      this.schema.personalDetails.model.name = customerDetails.fullName
      // this.schema.personalDetails.model.title = customerDetails?.title
      const phoneDetails = customerDetails.SMS
        ? customerDetails.SMS
        : customerDetails.TELEPHONE
      if (!customerDetails.phoneNumber.includes('+')) {
        if (customerDetails.phoneDetails && phoneDetails.isdCode) {
          // country code + phone number
          this.schema.personalDetails.model.phoneNumber = `${phoneDetails.isdCode} ${customerDetails.phoneNumber}`
        } else {
          // default country code + phone number
          this.schema.personalDetails.model.phoneNumber = `${this.defaultCountryCode} ${customerDetails.phoneNumber}`
        }
      }
      if (!this.enableAddressLookup && this.schema.personalDetails.schema.postCode) this.schema.personalDetails.schema.postCode.appendIcon = ''
      this.schema.personalDetails.model.dateOfBirth = this.$formatter.formatDate(customerDetails.dateOfBirth) || customerDetails.dateOfBirth
      this.schema.personalDetails.model.emailAddress = customerDetails.emailAddress
      if (customerDetails.isEnterpriseCustomer) {
        this.schema.personalDetails.schema.dateOfBirth.label = this.$t('personalSettings.label.enterpriseCustomerDOBLabel'
        )
      }
      if (this.storeData && !this.storeData.personalDetails) {
        store.dispatch('profileStore/setProfileData', {
          personalDetails: this.schema.personalDetails.model
        })
      }
      this.showOrHIdeSearchFields()
      Object.assign(this.schema.personalDetails.model, correspondence)
      store.dispatch('profileStore/setProfileData', {
        amendAddress: this.schema.personalDetails.model,
        form: {
          correspondenceAddress: this.schema.correspondence.model,
          residentialAddress: this.schema.residential.model
        }
      })

      if (this.isSmeLogin) { this.setSmeFormPersonalDetails() }
    },
    async setDisplayData () {
      const { originalUserData } = store.getters['profileStore/profileData']
      const { customerDetails } = originalUserData
      const getCustomerDetails = await CommonService.getCustomerDetails(this.username)
      let docDetailList = []
      this.documentDetails = []
      docDetailList = getCustomerDetails.basicDetails.documentDetails
      if (this.docTypes.length > 0) {
        docDetailList = docDetailList.filter(item => this.docTypes.includes(item.documentType))
      }
      docDetailList.sort((a, b) => {
        const date1 = new Date(a.kycExpiryDate)
        const date2 = new Date(b.kycExpiryDate)
        return date1 - date2
      })
      docDetailList = docDetailList.slice(0, this.documentListLimit)
      docDetailList.forEach(item => {
        this.documentDetails.push({
          label: item.documentTypeDescription,
          value: this.$formatter.formatDate(item.kycExpiryDate)
        })
      })
      // unHide Information after successful edit
      if (this.isSmeLogin) {
        this.schema.smePersonalDetails.schema.phoneNoValidity.hidden = this.hideSmePhoneNoValidity || false
        this.schema.smePersonalDetails.schema.emailValidity.hidden = this.hideSmeEmailValidity || false
      }
      this.schema.personalDetails.schema.emailValidity.hidden = this.hideEmailValidity || false
      this.schema.personalDetails.schema.phoneNoValidity.hidden = this.hidePhoneNoValidity || false
      this.schema.residential.schema.addressValidity.hidden = this.hideResidAddressValidity || false
      this.schema.correspondence.schema.addressValidity.hidden = this.hideCorrAddressValidity || false
      this.hideCorrespondenceAddress(false)

      let content = {}

      this.displayDataList = []
      this.correspondenceDisplayDataList = []
      this.residentialDisplayDataList = []
      this.otherInfoDIsplayDataList = []

      this.hideCorrespondenceAddress(false)
      content = {
        name: customerDetails && customerDetails.fullName ? customerDetails.fullName : '',
        dateOfBirth: customerDetails && customerDetails.dateOfBirth
          ? this.$formatter.formatDate(customerDetails.dateOfBirth) : '',
        userLoginId: this.getItem('username'),
        emailAddress: customerDetails && customerDetails.emailAddress ? customerDetails.emailAddress : '',
        phoneNumber: customerDetails && customerDetails.isdCode && customerDetails.phoneNumber
          ? `${customerDetails.isdCode} ${customerDetails.phoneNumber}` : ''
      }
      this.setPersonalDataList()
      this.setCorrespondenceDataList()
      this.setResidentialDataList()
      this.setOtherInfoDataList(getCustomerDetails)

      // Fetching Company Address
      if (this.isSmeLogin) {
        try {
          const { addressDetails, fatcaDetails } = getCustomerDetails.basicDetails
          let registeredOfficeAddress
          addressDetails.filter(item => {
            if (item.addressType === 'RO') {
              registeredOfficeAddress = item
            }
          })
          this.companyAddressDataList = this.getAddressDataList(registeredOfficeAddress)
          this.companyDisplayDataList = this.getCompanyTaxDataList(fatcaDetails[0])
        } catch (e) {
          console.log(e)
        }
      }
      this.setDisplayContent(content)
    },
    getCompanyTaxDataList (fatca) {
      if (fatca) {
        return [
          { label: 'giin', value: fatca.giin },
          { label: 'tin', value: fatca.tin },
          { label: 'taxClassificationDescription', value: fatca.taxClassificationDescription }
        ]
      }
      return []
    },
    async setDisplayContent () {
      const { originalUserData } = store.getters['profileStore/profileData']
      const { customerDetails, otherAddressTypes } = originalUserData
      this.residentialBeforeUpdate = null
      this.correspondenceBeforeUpdate = null

      const residential = this.getResidential(otherAddressTypes)
      if (residential) this.residentialBeforeUpdate = { ...residential }
      if (customerDetails.address) this.correspondenceBeforeUpdate = { ...customerDetails.address }
      this.setSmeDisplayPersonalInfo(customerDetails)
      this.setSmeDisplayInfo()
    },
    getResidential (otherAddressTypes) {
      return otherAddressTypes.find(address => address.addressType === 'HM')
    },
    getAddressDataList (address) {
      if (address) {
        return [
          { label: 'postCode', value: address.postCode },
          { label: 'country', value: address.countryDescription },
          { label: 'stateOrProvince', value: address.stateOrProvinceDescription },
          { label: 'townOrCity', value: address.townOrCity },
          { label: 'addressLine1', value: address.addressLine1 },
          { label: 'addressLine2', value: address.addressLine2 },
          { label: 'addressValidity', value: address.toDate }
        ]
      }
      return []
    },
    setSmeDisplayPersonalInfo (customerDetails = {}) {
      if (!this.isSmeLogin) { return }

      this.smePersonalInfo = []
      const { schema } = this.schema.smePersonalDetails
      console.log("schema",schema);
      
      const { fullName = '', isdCode = '', phoneNumber = '', completePhoneNumber = '', emailAddress = '' } = customerDetails
      console.log("customerDetails",customerDetails);
      
      const fieldMapping = {
        name: fullName,
        dateOfBirth:customerDetails.dateOfBirth,
        phoneNumber: isdCode && phoneNumber ? `${isdCode} ${phoneNumber}` : completePhoneNumber,
        emailAddress: emailAddress,
        phoneNoValidity: this.phoneValidity,
        emailValidity: this.emailValidity,
        smeCustomerId: this.isSmeLogin ? this.customerCode : this.corporateId,
        relatedPartyName: customerDetails.smeRelationshipDetails?.relatedPartyName || null,
        relationshipTypeDescription: customerDetails.smeRelationshipDetails?.relationshipType
          ? this.formatDescription(customerDetails.smeRelationshipDetails.relationshipType)
          : null
        
      }
      console.log("fieldMapping",fieldMapping);
      
      this.smePersonalInfo = Object.entries(schema)
        .filter(([, { hidden = false }]) => !hidden)
        .map(([field]) => {
          const value = fieldMapping[field] ?? null
          return value !== null ? { label: field, value } : null
        })
        .filter(item => item !== null)
    },
    setSmeDisplayInfo () {
      if (!this.isSmeLogin) { return }

      const desc = this.userCorporates.find(c => c?.corporateCode === this.defaultCorporateCode)?.formattedDescription
      this.smeInfo = []
      this.smeInfo.push(
        {
          label: 'defaultCorporateCode',
          value: desc || '-'
        }
      )
      // Adding the company address to display
      this.companyDisplayDataList.forEach((code) => {
        if (code.value) {
          this.smeInfo.push({
            label: code.label,
            value: code.value
          })
        }
      })
      this.smeAddressInfo = []
      this.companyAddressDataList.forEach((code) => {
        if (code.label === 'addressValidity') {
          this.smeAddressInfo.push({
            label: code.label,
            value: code.value ? this.$formatter.formatDate(code.value) : ''
          })
        } else {
          if (code.value) {
            this.smeAddressInfo.push({
              label: code.label,
              value: code.value
            })
          }
        }
      })
      if (this.schema.office.schema.addressValidity.hidden) {
        const companyAddress = this.smeAddressInfo
        this.smeAddressInfo = companyAddress.filter((item) => { return item.label !== 'addressValidity' })
      }
    },
    getCountryFieldList () {
      const countryList = []
      this.countryList.forEach((code) => {
        countryList.push({
          text: code.codeDescription,
          value: code.codeReference
        })
      })
      if (this.schema.residential.schema.country) this.schema.residential.schema.country.items = countryList
      if (this.schema.correspondence.schema.country) this.schema.correspondence.schema.country.items = countryList
    },
    setSmeFormDetails () {
      this.schema.smeDetails.model.defaultCorporateCode = this.defaultCorporateCode
      const smeList = []
      this.userCorporates.forEach((c) => {
        smeList.push({ corporateCode: c?.corporateCode, corporateDescription: c?.formattedDescription })
      })
      this.schema.smePersonalDetails.schema.phoneNoValidity.hidden = true
      this.schema.smePersonalDetails.schema.emailValidity.hidden = true
      this.schema.smeDetails.schema.defaultCorporateCode.items = smeList
      this.schema.smeDetails.schema.defaultCorporateCode.readonly = smeList.length <= 1
    },
    setSmeFormPersonalDetails () {
      this.schema.smePersonalDetails.model = {
        name: this.schema.personalDetails.model.name,
        emailAddress: this.schema.personalDetails.model.emailAddress,
        dateOfBirth:this.schema.personalDetails.model.dateOfBirth,
        phoneNumber: this.schema.personalDetails.model.phoneNumber,
        relatedPartyName: this.smePersonalInfo.find(e => e.label === 'relatedPartyName')?.value,
        relationshipTypeDescription: this.smePersonalInfo.find(e => e.label === 'relationshipTypeDescription')?.value,
        smeCustomerId: this.corporateId
      }
    },
    async updateAddressFields (address) {
      this.addressLookupData = []
      if (this.addressLookupServiceProvider?.toLowerCase() === 'loqate') {
        await this.updateAddressFieldsViaLoqateProvider(address)
        return
      }
      this.updateAddressFieldsViaDefaultProvider(address)
    },
    async updateAddressFieldsViaLoqateProvider (address) {
      const countrySelected = this.countryList.find(e => e.codeDescription === address.country)
      await this.getStatesList(countrySelected.codeReference)
      const stateSelected = this.statesList.find(e => e.stateOrProvinceDescription === address.stateOrProvince)
      const model = this.searchKey === 'searchResidentialAddress' ? this.schema.residential.model : this.schema.correspondence.model
      model.addressLine1 = address.addressLine1 || ''
      model.addressLine2 = address.addressLine2 || ''
      model.townOrCity = address.city || ''
      model.postCode = address.postCode ? address.postCode.replace(/\s/g, '') : ''
      model.country = countrySelected.codeReference || ''
      model.countryDescription = countrySelected.codeDescription || ''
      model.stateOrProvince = stateSelected?.stateOrProvince ?? ''
      model.stateOrProvinceDescription = stateSelected?.stateOrProvinceDescription ?? ''
    },
    async updateAddressFieldsViaDefaultProvider (address) {
      const countrySelected = this.countryList?.find(e => e.codeDescription === address.country)
      await this.getStatesList(countrySelected?.codeReference)
      const stateSelected = this.statesList.find(e => e.stateOrProvinceDescription === address.stateOrProvince)
      const model = this.searchKey === 'searchResidentialAddress' ? this.schema.residential.model : this.schema.correspondence.model
      model.addressLine1 = address.addressLine1 || ''
      model.addressLine2 = address.addressLine2 || ''
      model.townOrCity = address.city || ''
      model.postCode = address.postCode ? address.postCode.replace(/\s/g, '') : model.postCode.replace(/\s/g, '')
      model.country = countrySelected.codeReference || 'GBR'
      model.countryDescription = countrySelected.codeDescription || 'United Kingdom'
      model.stateOrProvince = stateSelected?.stateOrProvince ?? ''
      model.stateOrProvinceDescription = stateSelected?.stateOrProvinceDescription ?? ''
    },
    disableAddresses (value) {
      this.addAddressManually = value
      this.disableAddressFields(this.schema.residential.schema, !value)
      this.disableAddressFields(this.schema.correspondence.schema, !value)
    },
    setManualAddressEntry (e) {
      if (!this.enableAddressLookup) {
        this.disableAddressFields(this.schema.residential.schema, false)
        this.disableAddressFields(this.schema.correspondence.schema, false)
        return
      }
      if (this.enableManualAddressEntry) {
        this.disableAddressFields(this.schema.personalDetails.schema, false)
        this.disableAddressFields(this.schema.residential.schema, false)
        this.disableAddressFields(this.schema.correspondence.schema, false)
      } else {
        this.disableAddressFields(this.schema.personalDetails.schema, true)
        this.disableAddressFields(this.schema.residential.schema, true)
        this.disableAddressFields(this.schema.correspondence.schema, true)
      }
      // this.openAddressLookup = false
      if (!this.enableAddressAmendment) {
        this.preventAddressUpdate()
        if (this.schema.personalDetails.schema.postCode) this.schema.personalDetails.schema.postCode.disabled = true
        this.schema.residential.schema.postCode.disabled = true
        this.schema.correspondence.schema.postCode.disabled = true
        this.enableMandatoryAddressProofUpload = false
      }
      if (this.enableAddressAmendment && !this.enableManualEntryForAddressLookup && !this.enableAddressLookup) {
        this.disableAddressFields(this.schema.personalDetails.schema, false)
        this.disableAddressFields(this.schema.residential.schema, false)
        this.disableAddressFields(this.schema.correspondence.schema, false)
      }
    },
    preventAddressUpdate () {
      if (this.hasCorrespondence) {
        this.disableAddressFields(this.schema.correspondence.schema, true)
        this.schema.correspondence.schema.searchCorrespondenceAddress.hidden = true
        this.schema.correspondence.schema.uploadCorrespondenceProofBtn.disabled = true
        this.schema.correspondence.schema.sameAsResidential.hidden = true
        if (this.showUseForCommunicationOption && !this.schema.correspondence.schema.isDefault.hidden) {
          this.schema.correspondence.schema.isDefault.disabled = true
        }
      }
      if (this.hasResidential && this.showResidentialAddress) {
        this.disableAddressFields(this.schema.residential.schema, true)
        this.schema.residential.schema.searchResidentialAddress.hidden = true
        this.schema.residential.schema.uploadResidentialProofBtn.disabled = true
        if (this.showUseForCommunicationOption && !this.schema.residential.schema.isDefault.hidden) {
          this.schema.residential.schema.isDefault.disabled = true
        }
      }
    },
    disableAddressFields (schema, value = true) {
      if (schema.postCode) schema.postCode.disabled = value
      if (schema.addressLine1) schema.addressLine1.disabled = value
      if (schema.addressLine2) schema.addressLine2.disabled = value
      if (schema.townOrCity) schema.townOrCity.disabled = value
      if (schema.stateOrProvince) schema.stateOrProvince.disabled = false // TODO: find a better solution to trigger reactivity of this field
      if (schema.stateOrProvince) schema.stateOrProvince.disabled = value
    },
    setStateData () {
      const stateDetails = store.getters['profileStore/profileData'].fetchStateDetails
      if (this.statesList && this.statesList.length) {
        this.statesList.forEach((code) => {
          if (
            stateDetails &&
            stateDetails.stateOrProvince === code.stateOrProvince
          ) {
            this.schema.personalDetails.model.stateOrProvince = code.stateOrProvince
            this.schema.personalDetails.model.stateOrProvinceDescription = code.stateOrProvinceDescription
          }
        })
      }
    },
    updateCustomerPic (profilePic) {
      this.customerProfilePic = profilePic
    },
    onDocClose (e) {
      this.onProofClick = !e
    },
    reset () {
      this.onProofClick = true
    },
    setConfig (type) {
      this.selectUploadType = type
      this.selectModalTitle = type === 'customerDoc' ? this.$t('photoCapture.uploadPhoto') : this.$t('photoCapture.uploadProof')
    },
    onSave (type) {
      if (!this.isAddressProofValid()) {
        return
      }
      // TODO: this is a workaournd solution to  update the sme email address to the store
      if (this.isSmeLogin) {
        const storeData = store.getters['profileStore/profileData']
        const { personalDetails, customerDetails } = storeData
        personalDetails.emailAddress = this.schema.smePersonalDetails.model.emailAddress
        customerDetails.emailAddress = this.schema.smePersonalDetails.model.emailAddress
        store.dispatch('profileStore/setProfileData', {
          personalDetails: personalDetails,
          customerDetails: customerDetails
        })
      }

      if (type && this.enableOTP) {
        this.showOTPScreen = true
        return
      }

      if (!this.enableOTP) {
        this.amendCustomerDetails()
          .then(() => {
            if (this.isSmeLogin) { this.setDisplayData() }
          })
      }
    },
    isAddressProofValid () {
      const hasResidentialChange = this.showResidentialAddress ? this.hasResidentialChange() : false
      const hasCorrespondenceChange = this.hasCorrespondenceChange()

      if (!this.isSmeLogin) {
        if ((this.schema.residential.model.isDefault === true && this.schema.correspondence.model.isDefault === true) ||
          (this.schema.residential.model.isDefault === false && this.schema.correspondence.model.isDefault === false)) {
          this.dispatchError(this.$t('personalSettings.useForCommunicationError'))
          this.schema.residential.model.isDefault = false
          this.schema.correspondence.model.isDefault = false
          return false
        }

        if (hasResidentialChange) {
          store.dispatch('profileStore/setProfileData', {
            newResidentialAddr: this.schema.residential.model
          })
        }

        if (hasCorrespondenceChange) {
          store.dispatch('profileStore/setProfileData', {
            newCorrespondenceAddr: this.schema.correspondence.model
          })
        }
      }

      // Skip address proof validation for SME
      if (this.isSmeLogin) return true

      // if address upload is not mandatory
      if (!this.enableMandatoryAddressProofUpload) return true

      // Skip validation of address proof if both residential and corresspondence have not changed
      if (!hasResidentialChange && !hasCorrespondenceChange) return true

      // if customer has residential address and residential address has changed and residence is shown and no uploaded residential document
      if (this.hasResidential && hasResidentialChange && this.showResidentialAddress && !this.residentialDoc) {
        this.dispatchError(this.resource.residentialProofIsMandatory)
        return false
      }

      // if customer has correspondence address and correspondence address has changed and if same as residential checkbox is not tick and no uploaded correspondence document
      if (this.hasCorrespondence && hasCorrespondenceChange && !this.schema.correspondence.model.sameAsResidential && !this.correspondenceDoc) {
        this.dispatchError(this.resource.correspondenceProofIsMandatory)
        return false
      }

      return true
    },
    hasResidentialChange () {
      const { model: after } = this.schema.residential
      const { residentialBeforeUpdate: before } = this
      return this.hasAddressChanged(after, before)
    },
    hasCorrespondenceChange () {
      const { model: after } = this.schema.correspondence
      const { correspondenceBeforeUpdate: before } = this
      return this.hasAddressChanged(after, before)
    },
    hasAddressChanged (newAddress, oldAddress) {
      if (newAddress && oldAddress) {
        if (newAddress.postCode !== oldAddress.postCode) return true
        if (newAddress.country !== oldAddress.country) return true
        if (newAddress.townOrCity !== oldAddress.townOrCity) return true
        if (newAddress.addressLine1 !== oldAddress.addressLine1) return true
        if (newAddress.addressLine2 !== oldAddress.addressLine2) return true
        if (newAddress.stateOrProvince?.stateOrProvince) {
          if (newAddress.stateOrProvince.stateOrProvince !== oldAddress.stateOrProvince) return true
        } else {
          if (newAddress.stateOrProvince !== oldAddress.stateOrProvince) return true
        }
      }
      return false
    },
    async amendCustomerDetails () {
      this.resetApiFlags()
      try {
        this.showOTPScreen = false
        await this.uploadCustomerPhoto()
        await this.uploadAddressDocument()
        await this.updateDefaultCorporateCode()
        const amendResponse = await CommonService.amendCustomerDetails()
        this.showSuccessModal = true
        await this.isAmendSuccess(amendResponse)
      } catch (e) {
        store.dispatch('appStore/setAppData', { inProgress: false })
        console.log(e)
      }
    },
    async isAmendSuccess (amendResponse) {
      if (amendResponse && amendResponse.partyId) {
        this.amendSuccess = true
        this.updateForm = false
        this.enableManualAddressEntry = false
        this.isAmendComplete = true // check for completion of Amend process
        // fetch customer details API call
        this.isSmeLogin ? await preload.getCustomerDetails(this.customerCode) : await preload.getCustomerDetails(this.username)
        this.showSuccess()
        this.enableFormEdit = false
        this.updateAmendedData()
        this.deleteUploads()
        this.resetApiFlags()
        this.modalConfig.myProfileSuccess.enabled = true
      } else {
        this.modalConfig.myProfileFailed.enabled = true
        this.showFailure()
      }
    },
    async updateAmendedData () {
      await this.setDisplayData()
    },
    async uploadCustomerPhoto () {
      try {
        const { customerDocClippedFile } = store.getters['profileStore/profileData']

        // skipped if there is no uploaded photo
        if (!customerDocClippedFile) return

        const form = new FormData()
        form.append('image', customerDocClippedFile)
        form.append('partyId', this.isSmeLogin ? this.customerCode : this.username)
        form.append('imageType', this.customerPhotoDefaultData.imageType)
        form.append('captionInfo', this.customerPhotoDefaultData.captionInfo)
        this.apiCall.photo = true
        const response = await CommonService.uploadCustomerPhoto(form)
        if (response.imageId) this.success.photo = true
      } catch (e) { console.log(e) }
    },
    async uploadAddressDocument () {
      const { addressDoc } = store.getters['profileStore/profileData']
      if (!addressDoc) return

      try {
        const { residential, correspondence } = addressDoc
        if (residential) {
          this.apiCall.residential = true
          this.success.residential = await this.uploadAddressProofDoc(residential)
        }
        if (correspondence) {
          this.apiCall.correspondence = true
          this.success.correspondence = await this.uploadAddressProofDoc(correspondence)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async uploadAddressProofDoc (document) {
      try {
        const form = new FormData()
        form.append('document', document.clippedFile ? document.clippedFile : document.file)
        form.append('businessType', this.documentDefaultData.businessType)
        form.append('businessValue', this.isSmeLogin ? this.customerCode : this.username)
        form.append('docCategory', this.documentDefaultData.docCategory)
        form.append('docType', document.docType)
        form.append('userId', JSON.parse(sessionStorage.getItem('isSmeLogin'))
          ? JSON.parse(sessionStorage.getItem('corporateId'))
          : (JSON.parse(sessionStorage.getItem('customerCode')) || JSON.parse(sessionStorage.getItem('userId'))))
        const response = await CommonService.uploadAddressProofDoc(form)
        if (response && response.documentId) {
          /** Seperate and decrypt the response for security validation */
          const [key] = response.documentId.split('~')
          const decryptedKey = decrypt(key).replace(/^"(.*)"$/, '$1')

          return decryptedKey === document.file.name
        }
      } catch (e) {
        console.log(e)
      }
      return false
    },
    onAddressProof () {
      this.onProofClick = !this.onProofClick
    },
    confirmDelete (type) {
      this.deleteUploadType = type
      if (type) {
        const title = this.$t('photoCapture.deleteTitle') + ' ' + this.$t(`photoCapture.${type}`)
        const content = (type === 'residential' || type === 'correspondence')
          ? this.$t('photoCapture.confirmDelete') + ' ' + this.$t('photoCapture.confirmAddressDelete')
          : this.$t('photoCapture.confirmDelete') + ' ' + this.$t('photoCapture.confirmProfilePhotoDelete')
        store.dispatch('appStore/setAppData', {
          message: {
            title,
            content,
            type: 'success',
            saveButton: this.$t('common.yes'),
            cancelButton: this.$t('common.no'),
            saveCallback: this.deleteClippedImage,
            icon: 'mdi-delete',
            component: 'dob-modal'
          }
        })
      }
    },
    deleteClippedImage () {
      if (this.deleteUploadType === 'customerDoc') {
        this.showModal = false
        this.customerProfilePic = ''
        this.deleteUploadType = 'customerDoc'
        if (this.customerImageId) {
          this.deleteCustomerPhoto()
        }
      }

      if (this.deleteUploadType === 'residential' || this.deleteUploadType === 'correspondence') {
        const { addressDoc } = store.getters['profileStore/profileData']
        if (addressDoc) {
          delete addressDoc[this.deleteUploadType]
          store.dispatch('profileStore/setProfileData', { addressDoc })
          this[`${this.deleteUploadType}Doc`] = null
        }
      }
      this.checkFormSanity(true)
    },
    async deleteCustomerPhoto () {
      const deleteImgPayload = {
        reasonForDeletion: 'Removing profile photo from DOB application',
        userId: this.isSmeLogin ? this.customerCode : this.username
      }
      try {
        // delete customer profile photo
        await CommonService.deleteCustomerPhoto(
          this.customerImageId,
          deleteImgPayload
        )
      } catch (e) {
        console.log(e)
      }
    },
    checkFormSanity (arg) {
      Object.keys(this.schema.personalDetails.schema).filter((schemaKey) => {
        this.disableAddressForm = !this.schema.personalDetails.schema.addressLine1.readonly
      })
      Object.keys(this.schema.personalDetails.schema).filter((schemaKey) => {
        this.disablePersonalDetailsForm = !this.schema.personalDetails.schema.emailAddress.readonly
      })

      // Check for the upload & data availability
      if (
        this.disableAddressForm &&
        this.disablePersonalDetailsForm &&
        !this.docUploaded() &&
        !this.customerProfilePic
      ) {
        this.disableModify.saveForm = arg
      }
    },
    saveAmendData () {
      if (this.enableOTP) {
        this.amendCustomerDetails()
      } else {
        this.showSuccess()
        // fetch customer details API call
        this.isSmeLogin ? preload.getCustomerDetails(this.customerCode) : preload.getCustomerDetails(this.username)
      }
    },
    onSuccessModalClose () {
      this.resetMessage()
      this.showSuccessModal = false
    },
    showSuccess () {
      const { success: s, apiCall: a } = this
      this.amendMessage = ''
      this.amendMsgArray = []
      this.disableModify.saveForm = true
      event.$emit('resetEditToggle', true)

      // if api is triggered and api was successful -OR- api was not triggered
      const photoOk = (a.photo && s.photo) || !a.photo
      const residentialOk = (a.residential && s.residential) || !a.residential
      const correspondenceOk = (a.correspondence && s.correspondence) || !a.correspondence

      // show a single message if all API calls were successful
      if (photoOk && residentialOk && correspondenceOk) {
        this.amendMessage = this.$t('personalSettings.updateSuccess')
        return
      }

      this.addMessage(this.$t('userProfile.profileUpdateSuccess'), true)

      // Show different messages for every successful/failed api call
      if (a.photo) {
        s.photo ? this.addMessage(this.$t('userProfile.photoUploadSuccess'), true) : this.addMessage(this.$t('userProfile.photoUploadFailed'), false)
      }
      if (a.residential) {
        s.residential ? this.addMessage(this.$t('userProfile.residentAddUploadSuccess'), true) : this.addMessage(this.$t('userProfile.residentAddUploadFailed'), false)
      }
      if (a.correspondence) {
        s.correspondence ? this.addMessage(this.$t('userProfile.corrAddUploadSuccess'), true) : this.addMessage(this.$t('userProfile.corrAddUploadFailed'), false)
      }
    },
    addMessage (msg, checked) {
      this.amendMsgArray.push({ msg, checked })
    },
    showFailure () {
      this.amendMessage = this.$t('personalSettings.fileUpload.amendFailure')
      this.showSuccessModal = true
    },
    resetMessage () {
      this.amendMsgArray = []
      this.amendMessage = ''
    },
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    goingBack () {
      this.refresh = false
    },
    async updateDefaultCorporateCode () {
      if (!this.isSmeLogin) { return }
      const defaultCorporateCode = this.schema.smeDetails.model.defaultCorporateCode
      const { userId } = this
      const params = {
        userLoginId: userId,
        defaultCorporateCode: defaultCorporateCode
      }
      await CommonService.updateApplicationUserProfile(params)
      sessionStorage.setItem('defaultCorporateCode', JSON.stringify(defaultCorporateCode))
      this.defaultCorporateCode = defaultCorporateCode
    },
    get: (k) => JSON.parse(sessionStorage.getItem(k)),
    formatDescription: (v) => {
      const cap = (s) => { return s.charAt(0).toUpperCase() + s.slice(1) }
      const str = v.toLowerCase().split('@')
      const s1 = cap(str[0])
      const s2 = cap(str[1])
      return `${s1} / ${s2}`
    },
    hideCorrespondenceAddress (value) {
      const { schema: s } = this.schema.correspondence
      const v = value ?? this.schema.correspondence.model.sameAsResidential
      if (s.postCode) s.postCode.hidden = v
      if (s.country) s.country.hidden = v
      if (s.stateOrProvince) s.stateOrProvince.hidden = v
      if (s.townOrCity) s.townOrCity.hidden = v
      if (s.addressLine1) s.addressLine1.hidden = v
      if (s.addressLine2) s.addressLine2.hidden = v
      if (s.uploadCorrespondenceProofBtn) s.uploadCorrespondenceProofBtn.hidden = v
      if (s.searchCorrespondenceAddress) s.searchCorrespondenceAddress.hidden = v
      if (!this.isSmeLogin && this.showUseForCommunicationOption) {
        this.schema.correspondence.model.isDefault = false
        if (s.isDefault) s.isDefault.hidden = v
      }
    },
    enableSaveButton () {
      this.updateForm = true
      this.disableModify.saveForm = false
    },
    docUploaded () {
      return this.residentialDoc || this.correspondenceDoc
    },
    deleteUploads () {
      const profile = store.getters['profileStore/profileData']
      delete profile.addressDoc
      delete profile.customerDocClippedFile
      delete profile.customerImageFileName
      delete profile.customerImageFileType
      delete profile.file
      delete profile.fileName
      delete profile.fileType
      delete profile.clippedImageDataURL

      store.dispatch('profileStore/setProfileData', profile)
      this.residentialDoc = null
      this.correspondenceDoc = null
    },
    resetApiFlags () {
      this.success = {
        amend: false, photo: false, residential: false, correspondence: false
      }
      this.apiCall = {
        amend: false, photo: false, residential: false, correspondence: false
      }
    },
    showOrHIdeSearchFields () {
      if (this.enableAddressLookup) {
        this.schema.residential.schema.searchResidentialAddress.hidden = false
        this.schema.correspondence.schema.searchCorrespondenceAddress.hidden = false
        return
      }
      this.schema.residential.schema.searchResidentialAddress.hidden = true
      this.schema.correspondence.schema.searchCorrespondenceAddress.hidden = true
    },
    onSameAsResidentialChange ({ selected }) {
      this.hideCorrespondenceAddress(selected)
      this.enableSaveButton()
      if (!selected) {
        this.showOrHIdeSearchFields()
      }
    },
    isServiceNotAvailabe (response) {
      if (response?.data?.status === 500 || response?.data?.status === 400) return true
      return false
    },
    formatContact (contact) {
      const format = {
        EMAIL: (c) => `${c.contactMethodDescription} - ${c.contactValue}`,
        TELEPHONE: (c) => `${c.contactMethodDescription} - ${c.isdCode} ${c.contactValue}`,
        SMS: (c) => `${c.contactMethod} - ${c.contactMethodDescription} - ${c.isdCode} ${c.contactValue}`,
        POST: (c) => {
          if (c.contactType === 'HM') return `${c.contactMethodDescription} - Residence Address`
          if (c.contactType === '3') return `${c.contactMethodDescription} - Correspondence Address`
          if (c.contactType === 'RO') return `${c.contactMethodDescription} - Registered Office`
        },
        default: (c) => `${c.contactMethodDescription} - ${c.contactValue}`
      }
      return format[contact.contactMethod]?.(contact) || format.default(contact)
    },
    setPreferredContactList () {
      const { contactDetails = [] } = this.profileData.customerDetails
      const { schema, model } = this.schema.personalDetails
      const TODAY = moment().format('YYYY-MM-DD')

      model.preferredContact = 1
      schema.preferredContact.items = contactDetails
        .filter(c => {
          const isValidContactMethod = !['TELEX', 'FAX'].includes(c.contactMethod)
          const isNotRegisteredOffice = !(c.contactMethod === 'POST' && c.contactType === 'RO')
          const isNotExpired = !c.toDate || moment(c.toDate).isSameOrAfter(TODAY)
          return isValidContactMethod && isNotRegisteredOffice && isNotExpired
        })
        .map((c) => ({
          text: this.formatContact(c),
          value: c.contactPreferenceOrder,
          obj: c
        }))
    },
    onPersonalInput (e) {
      const { key, value } = e

      if (key === 'preferredContact') {
        const { customerDetails } = this.profileData
        const selectedContact = customerDetails.contactDetails.find(c => c.contactPreferenceOrder === value)
        if (selectedContact) {
          customerDetails.contactDetails = [
            selectedContact,
            ...customerDetails.contactDetails.filter(c => c.contactPreferenceOrder !== value)
          ]
          store.dispatch('profileStore/setProfileData', { customerDetails })
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.isPristine = !this.disableModify.saveForm
    if (this.enableFormEdit && (!this.isAmendComplete || this.isPristine)) {
      if (this.to) {
        next()
      } else if (this.isLogout) {
        this.to = to
        this.isLeavingRoute = false
        this.$router.push('/login')
      } else {
        this.to = to
        this.isLeavingRoute = true
      }
    } else {
      next()
    }
  }
}
</script>
